import React, { useState } from 'react';
export default function StripBio(props) {
    var fields = props.fields, children = props.children;
    return (React.createElement("div", { className: "strip spa-strip-bio" },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement("h1", null, fields.title),
                    React.createElement("p", null, fields.description))),
            React.createElement("div", { className: "row" }, children && children.map(function (child) { return (React.createElement(BioCard, { key: child.id, child: child })); })))));
}
function BioCard(_a) {
    var child = _a.child;
    var _b = useState(false), isExpanded = _b[0], setIsExpanded = _b[1];
    var description = child.fields.description;
    var isLongDescription = description.length > 163;
    var displayedDescription = isExpanded || !isLongDescription
        ? description
        : description.slice(0, 163) + '...';
    return (React.createElement("div", { className: "col-md-4" },
        React.createElement("div", { className: "card-bio" },
            React.createElement("div", { className: "img-container" },
                React.createElement("img", { src: child.fields.image, alt: child.fields.image_description || '', title: child.fields.image_title || '', className: "card-img-top" })),
            React.createElement("div", { className: "card-body" },
                React.createElement("h5", { className: "card-title" },
                    child.fields.firstName,
                    " ",
                    child.fields.lastName),
                React.createElement("h6", { className: "card-subtitle mb-2 text-muted" }, child.fields.function),
                React.createElement("p", { className: "card-text" }, displayedDescription),
                isLongDescription && (React.createElement("button", { onClick: function () { return setIsExpanded(!isExpanded); }, className: "btn btn-link" }, isExpanded ? 'Close' : 'Expand +'))))));
}
